import { render } from "./whiteCard.vue?vue&type=template&id=57a5b82c&scoped=true"
import script from "./whiteCard.vue?vue&type=script&lang=js"
export * from "./whiteCard.vue?vue&type=script&lang=js"

import "./whiteCard.vue?vue&type=style&index=0&id=57a5b82c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57a5b82c"

export default script